import { PageRootBlockSpec } from '@blocksuite/hive/blocks/root';
import { ToolbarModuleExtension } from '@blocksuite/hive/shared/services';
import {
  BlockFlavourIdentifier,
  LifeCycleWatcher,
} from '@blocksuite/hive/std';
import type { ExtensionType } from '@blocksuite/hive/store';
import type { FrameworkProvider } from '@toeverything/infra';

import { buildAIPanelConfig } from '../ai-panel';
import { toolbarAIEntryConfig } from '../entries';
import { setupSpaceAIEntry } from '../entries/space/setup-space';
import {
  HiveAIPanelWidget,
  aiPanelWidget,
} from '../widgets/ai-panel/ai-panel';
import { AiSlashMenuConfigExtension } from './ai-slash-menu';

function getAIPageRootWatcher(framework: FrameworkProvider) {
  class AIPageRootWatcher extends LifeCycleWatcher {
    static override key = 'ai-page-root-watcher';

    override mounted() {
      super.mounted();
      const { view } = this.std;
      view.viewUpdated.subscribe(payload => {
        if (payload.type !== 'widget' || payload.method !== 'add') {
          return;
        }
        const component = payload.view;
        if (component instanceof HiveAIPanelWidget) {
          component.style.width = '630px';
          component.config = buildAIPanelConfig(component, framework);
          setupSpaceAIEntry(component);
        }
      });
    }
  }
  return AIPageRootWatcher;
}

export function createAIPageRootBlockSpec(
  framework: FrameworkProvider
): ExtensionType[] {
  return [
    ...PageRootBlockSpec,
    aiPanelWidget,
    getAIPageRootWatcher(framework),
    ToolbarModuleExtension({
      id: BlockFlavourIdentifier('custom:hive:note'),
      config: toolbarAIEntryConfig(),
    }),
    AiSlashMenuConfigExtension(),
  ];
}
